import { ExchangeTheme } from './exchange';
import { SeatMapTheme } from './seat-map';
import Refund from './refund/ui/theme';
import * as Upsale from './upsale/ui/Upsale/Upsale.css';
export default {
    Upsale: {
        Upsale
    },
    Exchange: ExchangeTheme,
    SeatMap: SeatMapTheme,
    Refund
};
